import { useCallback } from 'react';
import { ManagerAuthorization } from '@common/enums';
import { assertHasAuthorization } from '@frontend/utils';
import type { ISelectableOption } from '../../../interfaces/selectableOption';
import { SelectableOptionsCard } from '../../carePath/cards/SelectableOptionsCard';

export interface ISelectableCard {
    extraComponent?: JSX.Element;
    linkedServiceGroupId?: string;
    selectableOptions: ISelectableOption[];
    sequence: number;
    subtitle?: string;
    title: string;
}

interface IOrganizationAddCarePathContentProps {
    cards: ISelectableCard[];
    hideEpisodeCategory: boolean;
    onChange: (id: string, sequence: number) => void;
}

export function OrganizationAddCarePathContent(props: IOrganizationAddCarePathContentProps) {
    assertHasAuthorization(ManagerAuthorization.organizationAddEdit);

    const contactDetailsForm = useCallback((contactFormNode: HTMLDivElement) => {
        if (contactFormNode !== null) {
            const input = contactFormNode.querySelector('div');
            if (input) {
                input.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, []);

    const cards = [...props.cards];

    if (props.hideEpisodeCategory) {
        cards.shift();
    }

    return (
        <>
            {cards.map((card) => (
                <div
                    key={card.sequence}
                    ref={contactDetailsForm}
                >
                    <SelectableOptionsCard
                        onChange={props.onChange}
                        selectableOptions={card.selectableOptions}
                        sequence={card.sequence}
                        subtitle={card.subtitle}
                        title={card.title}
                    />
                </div>
            ))}
        </>
    );
}
